<template>
  <div style="height: 100%;">
    <div class="bg" v-if="isBg" :style="{
      background: 'url(' + baseUrl + 'static/images/bg.png) no-repeat center center', backgroundSize: 'cover'
    }">
      <router-view />
    </div>
    <div class="bg2" v-if="isBg2" :style="{
      background: 'url(' + baseUrl + 'static/images/bg2.png) no-repeat center center', backgroundSize: 'cover'
    }">
      <router-view />
    </div>
  </div>
</template>
<script>
import config from '@/util/config.js'
export default {
  mounted () {
    this.baseUrl = config.relatedPath()
  },
  data () {
    return {
      isBg: true,
      isBg2: false,
      baseUrl: ''
    }
  },
  computed: {
    imgOneState () {
    // eslint-disable-next-line no-debugger
      return this.$store.state.pageBg.imgOne
    },
    imgTwoState () {
      return this.$store.state.pageBg.imgTwo
    }
  },
  watch: {
    imgOneState (newV) {
      this.isBg = newV
    },
    imgTwoState (newV) {
      this.isBg2 = newV
    }
  }
}
</script>
<style scoped lang="less">

.bg {
  /*
  background: url('static/images/bg.png');
  */
  filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale')";
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
  height: 100%;
}
.bg2 {
  /*
  background: url('static/images/bg2.png');
  */
  filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale')";
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
  height: 100%;
}

</style>
<style lang="less">
/*
.pen {
  cursor: url('/static/images/shubiao.png'), auto;
}
*/

* {
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app .el-container {
  width: 100%;
}

#app .el-header {
  width: 100%;
  height: 90px;
  padding-bottom: 10px;
  padding: 0;
}

/* 解决检索框分类栏  上下边框被遮挡*/
.el-input-group__append,
.el-input-group__prepend {
  overflow: hidden;
}

#app .el-main {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding: 0 0 20px 0;
}

#head .el-dropdown {
  font-size: 20px;
  color: #fff;
}

.bg2_backup {
  font: outline;
  background-color: rgb(180, 145, 91);
}

html,
body,
#app,
.el-container {
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
  overflow: hidden;
}

#imgBoxList .el-scrollbar__view {
  height: auto; /* 不设定一定高后  滚动条显示不出来*/
}

#imgBoxList .el-scrollbar__thumb {
  background-color: #fff;
}

#sbar .el-scrollbar__wrap {
  height: calc(100vh - 160px);
}

#sbar .el-scrollbar__view {
  padding-bottom: 30px;
  overflow-x: hidden;
}

#groupBar .el-scrollbar__wrap {
  height: calc(100vh - 160px);
}

#groupBar .el-scrollbar__view {
  padding-bottom: 30px;
  overflow-x: hidden;
}

#bimg {
  position: absolute;
  transition: 0.6s ease;
  -webkit-transition: 0.6s ease;
  -moz-transition: 0.6s ease;
  -ms-transition: 0.6s ease;
  -o-transition: 0.6s ease;

  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
}

#bigImg {
  position: absolute;
  transition: 0.6s ease;
  -webkit-transition: 0.6s ease;
  -moz-transition: 0.6s ease;
  -ms-transition: 0.6s ease;
  -o-transition: 0.6s ease;

  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
}

.onehand {
  cursor: move;
}

/*  分类检索菜单属性调整  不加ID 的话打包后就失效*/
#menu_type .el-menu-item-group__title {
  padding: 0px;
}
#menu_type .el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
}

#menu_type .el-menu-item,
#menu_type .el-submenu__title {
  height: 46px;
  line-height: 46px;
}

#imgBoxListFav .el-image__inner {
  width: auto;
}

#dhlist > .el-breadcrumb {
  font-size: 20px;
  line-height: 1;
}
#dhlist .el-breadcrumb__inner a,
#dhlist .el-breadcrumb__inner.is-link {
  color: #fff;
  font-size: 20px;
}

#dhlist .el-breadcrumb__item:last-child .el-breadcrumb__inner,
#dhlist .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
#dhlist .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
#dhlist .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 700;
  color: #fff;
  cursor: pointer;
}

/* 滑动条下方隐藏 */
.el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
}

/* components\feedback\mainPostList.vue */
.el-select-dropdown__list {
  height: 360px;
}

/** components\image\favoritesImageList.vue */
.el-pager li {
  background-color: transparent;
  font-size: 16px;
}

.el-pagination .btn-next,
.el-pagination .btn-prev {
  background-color: transparent;
}
.el-pagination button:disabled {
  background-color: transparent;
}
.el-pagination {
  color: #fff;
}
.el-pagination__total {
  font-weight: 500;
  color: #f5f7fa;
}
.el-pagination__jump {
  font-weight: 500;
  color: #fff;
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}
.el-pager li.active {
  color: blue;
}
.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  line-height: 28px;
  color: #fff;
}

.el-input__inner {
  background-color: transparent;
  color: #000; /** 不要动这里, 这里的颜色控制着忘记密码的输入框里面的文字的颜色 */
}

/**components\image\historyDialog.vue */
.el-dialog {
  width: 70%;
}

/**components\image\ibox\iBoxInfavorites.vue */
/* 覆盖饿了么 默认样式  莫要加 scoped */
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: auto;
  height: auto;
}

.el-tooltip__popper {
  z-index: 2;
}

.el-image {
  position: relative;
  display: block;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.iimg2 img {
  cursor: pointer;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  -ms-border-radius: 12px;
  -o-border-radius: 12px;

  max-width: 90%;
  max-height: 90%;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  position: absolute;
  display: block;
  /*
  width: calc(100% - 15px);  //运算符是英文格式下的   并且两侧必须有空格

    这个类它跨vue文件了, 后期需要处理一下
   */
}
/**components\image\ibox\iBoxInThumbnail.vue */
/* 覆盖饿了么 默认样式  莫要加 scoped */
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: auto;
  height: auto;
}
.el-tooltip__popper {
  z-index: 2;
}
.iimg img {
  cursor: pointer;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  -ms-border-radius: 12px;
  -o-border-radius: 12px;
  /*
    max-width: 90%;
    max-height: 90%;
    */
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
}

/**components\userCenter\menu.vue */
.el-menu {
  background-color: transparent;
  border: 0px;
}

.el-menu-item {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
}
.el-menu-item:hover {
  color: crimson;
}
.el-menu-item.is-active {
  color: #fff;
}

.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: transparent;
}

.el-submenu__icon-arrow {
  font-size: 22px;
}
.el-submenu__title i {
  color: #fff;
}

.el-menu-item,
.el-submenu__title {
  line-height: 46px;
  height: 46px;
}

.el-submenu__icon-arrow {
  top: 40%;
}

/** components\feedback\mainPostList.vue */
.mainPostListPageComponentClass .el-scrollbar,
.mainPostListPageComponentClass .el-scrollbar__view {
  height: 110px;
}
/** components\feedback\subPostList\subPostList.vue */
.subPostListPageComponentClass .el-scrollbar,
.subPostListPageComponentClass .el-scrollbar__view {
  height: 110px;
}

/** components\userCenter\shopRecords.vue */
.shopRecordsPageComponentClass .el-scrollbar,
.shopRecordsPageComponentClass .el-scrollbar__view {
  height: 186px;
}
</style>
